var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65625 0.102345C1.05469 -0.0804795 1.52344 -0.0148502 1.85625 0.271106L3.75 1.89309L5.64375 0.271106C6.06563 -0.0898551 6.68906 -0.0898551 7.10625 0.271106L9 1.89309L10.8937 0.271106C11.3156 -0.0898551 11.9391 -0.0898551 12.3563 0.271106L14.25 1.89309L16.1437 0.271106C16.4766 -0.0148502 16.9453 -0.0804795 17.3438 0.102345C17.7422 0.285169 18 0.683633 18 1.12429V22.8757C18 23.3164 17.7422 23.7148 17.3438 23.8977C16.9453 24.0805 16.4766 24.0149 16.1437 23.7289L14.25 22.1069L12.3563 23.7289C11.9344 24.0899 11.3109 24.0899 10.8937 23.7289L9 22.1069L7.10625 23.7289C6.68438 24.0899 6.06094 24.0899 5.64375 23.7289L3.75 22.1069L1.85625 23.7289C1.52344 24.0149 1.05469 24.0805 0.65625 23.8977C0.257812 23.7148 0 23.3164 0 22.8757V1.12429C0 0.683633 0.257812 0.285169 0.65625 0.102345ZM4.5 6.74966C4.0875 6.74966 3.75 7.08718 3.75 7.4997C3.75 7.91223 4.0875 8.24975 4.5 8.24975H13.5C13.9125 8.24975 14.25 7.91223 14.25 7.4997C14.25 7.08718 13.9125 6.74966 13.5 6.74966H4.5ZM3.75 16.5003C3.75 16.9128 4.0875 17.2503 4.5 17.2503H13.5C13.9125 17.2503 14.25 16.9128 14.25 16.5003C14.25 16.0878 13.9125 15.7502 13.5 15.7502H4.5C4.0875 15.7502 3.75 16.0878 3.75 16.5003ZM4.5 11.25C4.0875 11.25 3.75 11.5875 3.75 12C3.75 12.4125 4.0875 12.75 4.5 12.75H13.5C13.9125 12.75 14.25 12.4125 14.25 12C14.25 11.5875 13.9125 11.25 13.5 11.25H4.5Z",
    fill: "url(#paint0_linear_59_328)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_59_328",
    x1: 9,
    y1: 0,
    x2: 9,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DD0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1891B4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.08574283a16e29c30c4764f71544f465.svg";
export { ForwardRef as ReactComponent };